import {resolveBackground} from '#core/utils/color-utils.js';

export function futureRacingFactory(PALETTE) {
    return {
        NextRaces: {
            nextOffTitle: {
                style: {
                    ...PALETTE.NEXT_RACES_HEADER_TEXT,
                },
            },
        },
        // yes, it's a correct place because Mojito use this skeleton only inside NextRaces component,
        // and we need to have identical styles for both these titles
        RaceCardsSkeleton: {
            title: {
                style: {
                    ...PALETTE.NEXT_RACES_HEADER_TEXT,
                },
            },
        },
        FutureRaceCard: {
            container: {
                style: {
                    ...resolveBackground(PALETTE.FUTURE_RACE_CARD_CONTAINER_BG),
                    minHeight: '70px',
                    ...PALETTE.FUTURE_RACE_CARD_TEXT,
                },
            },
            raceInfoContainer: {
                style: {
                    padding: 0,
                },
            },
            raceDate: {
                container: {
                    padding: 8,
                    borderStyle: 'solid',
                    borderColor: PALETTE.FUTURE_RACE_CARD_DATE_CONTAINER_SEPARATOR_COLOR,
                    borderWidth: '0 0 1px',
                    ...resolveBackground(PALETTE.FUTURE_RACE_CARD_DATE_CONTAINER_BG),
                },
                style: {
                    ...PALETTE.FUTURE_RACE_CARD_DATE_TEXT,
                },
            },
            eventName: {
                container: {
                    padding: '8px 8px 0',
                    ...resolveBackground(PALETTE.FUTURE_RACE_CARD_EVENT_NAME_CONTAINER_BG),
                },
                style: {
                    ...PALETTE.FUTURE_RACE_CARD_EVENT_NAME_TEXT,
                },
            },
            eachWayTerms: {
                style: {
                    padding: 8,
                    ...PALETTE.FUTURE_RACE_CARD_EW_TERMS_TEXT,
                },
            },
            runnersSeparator: {
                style: {
                    color: PALETTE.FUTURE_RACE_CARD_RUNNERS_SEPARATOR_COLOR,
                },
            },
        },
        FutureRunnerInfo: {
            runnerName: {
                style: {
                    ...PALETTE.FUTURE_RACE_CARD_RUNNER_INFO.RUNNER_NAME_TEXT,
                },
            },
        },
        FutureRacesView: {
            locationName: {
                style: {
                    padding: '8px',
                    ...resolveBackground(PALETTE.FUTURE_RACES_LOCATION_NAME_CONTAINER_BG),
                    ...PALETTE.FUTURE_RACES_LOCATION_NAME_TEXT,
                },
            },
            raceName: {
                style: {
                    ...PALETTE.FUTURE_RACE_NAME_TEXT,
                },
            },
            // better to leave it like it is now because it's button but visually it's something else
            raceContainer: {
                style: {
                    base: {
                        padding: '8px',
                        ...PALETTE.FUTURE_RACES_TEXT,
                    },
                },
            },
            racesList: {
                style: {
                    padding: '0 0 16px',
                    _mobile_padding: '0 0 8px',
                    boxShadow: PALETTE.FUTURE_RACES_LIST_CONTAINER_SHADOW,
                    ...resolveBackground(PALETTE.FUTURE_RACES_LIST_CONTAINER_BG),
                },
            },
            raceIcon: {
                style: {
                    fill: PALETTE.FUTURE_RACE_ICON_COLOR,
                },
            },
        },
    };
}
